/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Access_GrantedInputs */

const en_access_granted = /** @type {(inputs: Access_GrantedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access granted!`)
};

const es_access_granted = /** @type {(inputs: Access_GrantedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Acceso concedido!`)
};

const fr_access_granted = /** @type {(inputs: Access_GrantedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès autorisé !`)
};

const de_access_granted = /** @type {(inputs: Access_GrantedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugang gewährt!`)
};

const id_access_granted = /** @type {(inputs: Access_GrantedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses diberikan!`)
};

/** @type {(inputs: Access_GrantedInputs) => LocalizedString} */
const ja_access_granted = en_access_granted;

/** @type {(inputs: Access_GrantedInputs) => LocalizedString} */
const zh_access_granted = en_access_granted;

/** @type {(inputs: Access_GrantedInputs) => LocalizedString} */
const ar_access_granted = en_access_granted;

/** @type {(inputs: Access_GrantedInputs) => LocalizedString} */
const it_access_granted = en_access_granted;

/** @type {(inputs: Access_GrantedInputs) => LocalizedString} */
const ru_access_granted = en_access_granted;

/** @type {(inputs: Access_GrantedInputs) => LocalizedString} */
const pt_access_granted = en_access_granted;

/** @type {(inputs: Access_GrantedInputs) => LocalizedString} */
const ko_access_granted = en_access_granted;

/**
* | output |
* | --- |
* | "Access granted!" |
*
* @param {Access_GrantedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const access_granted = /** @type {((inputs?: Access_GrantedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Access_GrantedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_access_granted(inputs)
	if (locale === "es") return es_access_granted(inputs)
	if (locale === "fr") return fr_access_granted(inputs)
	if (locale === "de") return de_access_granted(inputs)
	if (locale === "ja") return ja_access_granted(inputs)
	if (locale === "zh") return zh_access_granted(inputs)
	if (locale === "ar") return ar_access_granted(inputs)
	if (locale === "id") return id_access_granted(inputs)
	if (locale === "it") return it_access_granted(inputs)
	if (locale === "ru") return ru_access_granted(inputs)
	if (locale === "pt") return pt_access_granted(inputs)
	return ko_access_granted(inputs)
});